import { useEffect } from 'react';

import CustomerAccountService from 'root/apps/QuoteMachineIntegration/services/CustomerAccountService';
import { CustomerAccount as CreditAccountData } from 'root/apps/QuoteMachineIntegration/state';
import Modules from 'root/apps/shared_modules/Modules';

interface UseBalanceDriftDetectionParams {
  creditAccountID: string;
  invoicingData: CreditAccountData | undefined;
  lsrBalanceOwed: number | null;
  lsrDepositBalance: number | null;
}

/**
 * Detects balance discrepancies between LSR and Invoicing systems.
 * Reports drift to the Invoicing API when any difference is detected.
 */
export const useBalanceDriftDetection = ({
  creditAccountID,
  invoicingData,
  lsrBalanceOwed,
  lsrDepositBalance,
}: UseBalanceDriftDetectionParams) => {
  useEffect(() => {
    if (
      !Modules.hasModule('invoicing.api.v1.balance_drift') ||
      !invoicingData ||
      invoicingData.invoicingContactId === 'undefined' // Contact do not exist in Invoicing
    ) {
      return;
    }

    const invoicingOwing = invoicingData.owingBalance ?? 0;
    const invoicingDeposit = invoicingData.depositBalance ?? 0;
    const lsrOwing = lsrBalanceOwed ?? 0;
    const lsrDeposit = lsrDepositBalance ?? 0;

    const owingDrift = Math.abs(invoicingOwing - lsrOwing);
    const depositDrift = Math.abs(invoicingDeposit - lsrDeposit);

    const hasDrift = owingDrift > 0 || depositDrift > 0;

    if (hasDrift) {
      CustomerAccountService.reportBalanceDrift(creditAccountID);
    }
  }, [invoicingData, lsrBalanceOwed, lsrDepositBalance, creditAccountID]);
};
